webpackJsonp([248],{

/***/ 1214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PositionAuditDetail_vue__ = __webpack_require__(2926);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_298c11a0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PositionAuditDetail_vue__ = __webpack_require__(5224);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PositionAuditDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_298c11a0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PositionAuditDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1357), __esModule: true };

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1358);


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var get = __webpack_require__(145);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1381);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1352);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 1381:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1382), __esModule: true };

/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1383);


/***/ }),

/***/ 1383:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(146);
var ITERATOR = __webpack_require__(22)('iterator');
var Iterators = __webpack_require__(66);
module.exports = __webpack_require__(12).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 2926:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      creator: this.$route.query.creator,
      id: this.$route.params.id,
      form: {
        industry_type: null,
        position_type: null,
        title: null,
        hire_number: 0,
        address: null,
        employer_name: null,
        position_period: null,
        working_shifts: null,
        working_hours: null,
        gender: null,
        age_range: null,
        certificate: null,
        education: null,
        marriage: null,
        working_experience: null,
        other_requirements: null,
        salary: null,
        salary_type: null,
        commission: null,
        quarterly_bonus: null,
        insurance: null,
        overtime_pay: null,
        meal_allowance: null,
        commute_allowance: null,
        phone_allowance: null,
        welfare: null,
        settlement_type: null,
        settlement_time: null,
        status: null,
        province_name: null,
        city_name: null,
        area_name: null,
        proof: [],
        errorFields: [],
        email: null,
        contactto: null
      },
      checkForm: {
        userid: null,
        realname: null,
        level: null,
        currentstatus: null,
        current_location: [],
        cellphone: null,
        registertime: null,
        balance: 0,
        frozenbalance: 0,
        totalwithdraw: 0,
        frozenpoints: 0,
        points: 0,
        spendpoints: 0
      },
      options: {
        industry_type: [],
        salary: [],
        position_type: [],
        salary_type: [],
        gender: [],
        settlement_type: [],
        settlement_time: [],
        education: [],
        marriage: [],
        insurance: [],
        level: [],
        currentstatus: []
      }
    };
  },

  computed: Vuex.mapState({}),
  created: function created() {
    var _this = this;

    request.all.page([request('getPostionForm', this.id), request('editPostionOptions'), request('getUserDetail', this.creator), request('getUserRelatedOptions'), request('getUserCredit', this.creator), request('getUserPoints', this.creator)]).then(function (_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 6),
          postionForm = _ref2[0],
          postionOptions = _ref2[1],
          userDetail = _ref2[2],
          relatedOptions = _ref2[3],
          userCredit = _ref2[4],
          userPoints = _ref2[5];

      (function (_ref3) {
        var data = _ref3.data;

        filter.setLoop(_this.form, data);
      })(postionForm);(function (_ref4) {
        var data = _ref4.data;

        filter.setLoop(_this.options, data);
      })(postionOptions);(function (_ref5) {
        var data = _ref5.data;

        filter.setLoop(_this.checkForm, data);
      })(userDetail);(function (_ref6) {
        var data = _ref6.data;

        filter.setLoop(_this.options, data);
      })(relatedOptions);(function (_ref7) {
        var data = _ref7.data;

        filter.setLoop(_this.checkForm, data);
      })(userCredit);(function (_ref8) {
        var data = _ref8.data;

        filter.setLoop(_this.checkForm, data);
      })(userPoints);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions(['getPostionForm', 'editPostionOptions', 'getUserCredit', 'getUserPoints', 'getUserDetail', 'getUserRelatedOptions']))
});

/***/ }),

/***/ 5224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v("\n      "+_vm._s(_vm.$route.meta.title)+"\n    ")]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("招聘管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/position/detail/'+_vm.id}}},[_vm._v("职位列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"show-header":false}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"label-width":"80px","size":"mini"}},[_c('el-row',{staticClass:"text item"},[_c('el-col',{attrs:{"span":24}},[_c('h2',[_vm._v("基本信息")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"行业大类:"}},_vm._l((_vm.options.industry_type),function(industryType){return (industryType.id === _vm.form.industry_type)?_c('span',[_vm._v("\n            "+_vm._s(industryType.keyword)+"\n          ")]):_vm._e()}),0),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'industry_type')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("*"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"职位类型:"}},_vm._l((_vm.options.position_type),function(positionType){return (positionType.id === _vm.form.position_type)?_c('span',[_vm._v("\n            "+_vm._s(positionType.keyword)+"\n          ")]):_vm._e()}),0),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'position_type')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("*"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"岗位名称:"}},[_vm._v(_vm._s(_vm.form.title))]),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'title')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("\n          *"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"招聘人数:"}},[_vm._v(_vm._s(_vm.form.hire_number))]),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'hire_number')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("*"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工作地点:"}},[_vm._v(_vm._s(_vm.form.province_name)+"-"+_vm._s(_vm.form.city_name)+"-"+_vm._s(_vm.form.area_name)+"       \n          "+_vm._s(_vm.form.address)+"\n        ")]),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'address')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("\n          *"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"发布单位:"}},[_vm._v(_vm._s(_vm.form.employer_name))]),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'employer_name')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("*"+_vm._s(value.message)+"\n        ")]):_vm._e()})],2),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-row',{staticClass:"text item"},[_c('el-col',{attrs:{"span":24}},[_c('h2',[_vm._v("职位描述")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工作时间:"}},[_vm._v(_vm._s(_vm.form.position_period))]),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'position_period')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("*"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工作班次:"}},[_vm._v(_vm._s(_vm.form.working_shifts))]),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'working_shifts')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("*"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工作时长:"}},[_vm._v(_vm._s(_vm.form.working_hours))]),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'working_hours')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("*"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"性别要求:"}},_vm._l((_vm.options.gender),function(gender){return (gender.id === _vm.form.gender)?_c('span',[_vm._v("\n            "+_vm._s(gender.keyword)+"\n          ")]):_vm._e()}),0),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'gender')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("\n          *"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"年龄要求:"}},[_vm._v(_vm._s(_vm.form.age_range))]),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'age_range')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("\n          *"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"证件要求:"}},[_vm._v(_vm._s(_vm.form.certificate))]),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'certificate')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("*"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"学历要求:"}},_vm._l((_vm.options.education),function(education){return (education.id === _vm.form.education)?_c('span',[_vm._v("\n            "+_vm._s(education.keyword)+"\n          ")]):_vm._e()}),0),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'education')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("\n          *"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"婚姻状况:"}},_vm._l((_vm.options.marriage),function(marriage){return (marriage.id === _vm.form.marriage)?_c('span',[_vm._v("\n            "+_vm._s(marriage.keyword)+"\n          ")]):_vm._e()}),0),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'marriage')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("\n          *"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工作经验:"}},[_vm._v(_vm._s(_vm.form.working_experience))]),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'working_experience')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("*"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"补充说明:"}},[_vm._v(_vm._s(_vm.form.other_requirements))]),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'other_requirements')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("*"+_vm._s(value.message)+"\n        ")]):_vm._e()})],2),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-row',{staticClass:"text item"},[_c('el-col',{attrs:{"span":24}},[_c('h2',[_vm._v("薪资福利")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"基本薪资:"}},[_vm._l((_vm.options.salary),function(salary){return (salary.id === _vm.form.salary)?_c('span',[_vm._v(_vm._s(salary.keyword))]):_vm._e()}),_vm._v(" "),_vm._l((_vm.options.salary_type),function(salaryType){return (salaryType.id === _vm.form.salary_type)?_c('span',[_vm._v("\n            "+_vm._s(salaryType.keyword)+"\n          ")]):_vm._e()})],2),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'salary')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("\n          *"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"提成机制:"}},[_vm._v(_vm._s(_vm.form.commission))]),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'commission')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("\n          *"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"季度奖金:"}},[_vm._v(_vm._s(_vm.form.quarterly_bonus))]),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'quarterly_bonus')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("*"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"社保缴纳:"}},_vm._l((_vm.options.insurance),function(insurance){return (insurance.id === _vm.form.insurance)?_c('span',[_vm._v("\n            "+_vm._s(insurance.keyword)+"\n          ")]):_vm._e()}),0),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'insurance')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("\n          *"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"加班补助:"}},[_vm._v(_vm._s(_vm.form.overtime_pay))]),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'overtime_pay')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("*"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"餐饮补助:"}},[_vm._v(_vm._s(_vm.form.meal_allowance))]),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'meal_allowance')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("*"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"交通补助:"}},[_vm._v(_vm._s(_vm.form.commute_allowance))]),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'commute_allowance')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("*"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"话费补助:"}},[_vm._v(_vm._s(_vm.form.phone_allowance))]),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'phone_allowance')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("*"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"其他福利:"}},[_vm._v(_vm._s(_vm.form.welfare))]),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'welfare')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("\n          *"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"结算方式:"}},_vm._l((_vm.options.settlement_type),function(settlementType){return (settlementType.id === _vm.form.settlement_type)?_c('span',[_vm._v("\n            "+_vm._s(settlementType.keyword)+"\n          ")]):_vm._e()}),0),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'settlement_type')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("*"+_vm._s(value.message)+"\n        ")]):_vm._e()}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"结算时间:"}},_vm._l((_vm.options.settlement_time),function(settlementTime){return (settlementTime.id === _vm.form.settlement_time)?_c('span',[_vm._v("\n            "+_vm._s(settlementTime.keyword)+"\n          ")]):_vm._e()}),0),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'settlement_time')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("*"+_vm._s(value.message)+"\n        ")]):_vm._e()})],2)],1),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.checkForm,"label-width":"80px","size":"mini"}},[_c('el-row',{staticClass:"text item"},[_c('el-col',{attrs:{"span":24}},[_c('h2',[_vm._v("审核信息")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"用户id:"}},[_vm._v(_vm._s(_vm.checkForm.userid))])],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"用户真名:"}},[_vm._v(_vm._s(_vm.checkForm.realname))])],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"用户等级:"}},_vm._l((_vm.options.level),function(value){return (value.id === _vm.checkForm.level)?_c('span',[_vm._v("\n              "+_vm._s(value.keyword)+"\n            ")]):_vm._e()}),0)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"当前状态:"}},_vm._l((_vm.options.currentstatus),function(value){return (value.id === _vm.checkForm.currentstatus)?_c('span',[_vm._v("\n              "+_vm._s(value.keyword)+"\n            ")]):_vm._e()}),0)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"所在地:"}},[_vm._v(_vm._s(_vm.checkForm.current_location.system))])],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"手机号:"}},[_vm._v(_vm._s(_vm.checkForm.cellphone))])],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"电子邮箱:"}},[_vm._v(_vm._s(_vm.form.email))])],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"注册时间:"}},[_vm._v(_vm._s(_vm.checkForm.registertime))])],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"赏金信息:"}},[_vm._v("可提现金额: "+_vm._s(_vm.checkForm.balance)+" 冻结金额: "+_vm._s(_vm.checkForm.frozenbalance)+" 已提现金额:\n            "+_vm._s(_vm.checkForm.totalwithdraw)+"\n          ")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"零豆信息:"}},[_vm._v("积分总数: "+_vm._s(_vm.checkForm.points)+"     冻结积分:\n            "+_vm._s(_vm.checkForm.frozenpoints)+"     已花费积分: "+_vm._s(_vm.checkForm.spendpoints)+"\n          ")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"图片证据:"}},[_vm._l((_vm.form.proof),function(value){return _c('div',[(value)?_c('a',{attrs:{"href":value,"target":"_Blank"}},[_c('img',{staticStyle:{"border-radius":"50px"},attrs:{"src":value+'?x-oss-process=image/resize,w_100/auto-orient,1',"width":"100px;","height":"100px;"}})]):_vm._e()])}),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'proof')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("\n              *"+_vm._s(value.message)+"\n            ")]):_vm._e()})],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"联系电话:"}},[_vm._v(_vm._s(_vm.form.contactto))]),_vm._v(" "),_vm._l((_vm.form.errorFields),function(value){return (value.field === 'contactto')?_c('div',{staticStyle:{"margin-top":"-20px","color":"red"}},[_vm._v("*"+_vm._s(value.message)+"\n          ")]):_vm._e()})],2),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"发布单位:"}},[_vm._v("\n            "+_vm._s(_vm.form.employer_name)+"\n          ")])],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"text-align":"center"}},[_c('Br'),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/position/audit-table'}}},[_c('el-button',[_vm._v("返回")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/248.fbee456be4ff3d6e0348.js